import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";
import { Stars } from "@/components/support/RateTicket";

export function SupportRatings({ admin }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (open) api.get("/support/ratings").then((r) => setData(r.data));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full gap-2" data-testid="ratings-btn"><Star className="w-4 h-4" /> التقييمات</Button>
      </DialogTrigger>
      <DialogContent dir="rtl" className="max-w-xl" data-testid="ratings-dialog">
        <DialogHeader><DialogTitle>{admin ? "تقييمات خدمة العملاء" : "تقييمات تذاكري"}</DialogTitle></DialogHeader>
        {!data ? <div className="py-8 text-center text-sm text-muted-foreground">جارٍ التحميل...</div> : (
          <div className="space-y-4">
            <div className="flex items-center gap-4 rounded-xl bg-amber-50/70 p-4">
              <div className="text-3xl font-bold" data-testid="ratings-avg">{data.avg || "—"}</div>
              <div><Stars value={Math.round(data.avg)} size="w-4 h-4" testid="ratings-avg-stars" />
                <div className="text-xs text-muted-foreground mt-1" data-testid="ratings-count">{data.count} تقييم</div></div>
            </div>
            {admin && data.agents.length > 0 && (
              <div className="grid sm:grid-cols-2 gap-2" data-testid="ratings-agents">
                {data.agents.map((a) => (
                  <div key={a.id} className="rounded-xl border border-border p-3 flex justify-between text-sm" data-testid={`ratings-agent-${a.id}`}>
                    <span className="font-semibold">{a.name}</span>
                    <span className="text-muted-foreground">{a.avg} ★ · {a.count}</span>
                  </div>
                ))}
              </div>
            )}
            <div className="max-h-72 overflow-y-auto divide-y divide-border">
              {data.items.length === 0 && <div className="py-6 text-center text-sm text-muted-foreground" data-testid="ratings-empty">لا توجد تقييمات بعد</div>}
              {data.items.map((it) => (
                <div key={it.id} className="py-2.5 space-y-1" data-testid={`rating-row-${it.id}`}>
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-sm font-semibold truncate">#{it.number} · {it.subject}</span>
                    <Stars value={it.stars} size="w-3.5 h-3.5" testid={`rating-row-stars-${it.id}`} />
                  </div>
                  <div className="text-xs text-muted-foreground">{it.user_name}{admin && ` · الموظف: ${it.assigned_name}`}</div>
                  {it.comment && <div className="text-xs">«{it.comment}»</div>}
                </div>
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
